import { Suspense, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { Capacitor } from "@capacitor/core";

import ErrorBoundary from "~/components/ErrorBoundary";
import openExternal from "~/util/openExternal";

import FormLoadingSkeleton from "./FormLoadingSkeleton";
import Header from "./Header";

const LayoutForms = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const formUrl = `${window.location.origin}/app${pathname}${search}`;
      openExternal(formUrl);
      navigate("/landlord/documents", { replace: true });
    }
  }, []);

  return (
    <>
      <Header />
      <div id="CIO_message" />
      <ErrorBoundary boundaryName="FormsSystem" fallbackMode="detailed">
        <Suspense fallback={<FormLoadingSkeleton />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    </>
  );
};

export default LayoutForms;
